import React from "react";
import ContratItem from "./ContractItem";
import Table from "react-bootstrap/Table";
import CardsList from "../../UI/CardsList/CardsList";

export default function ListContracts(props) {
  const contracts = props.contracts;
  function closeContractHandler(id, p) {
    props.onCloseContract(id, p);
  }
  function assignContractHandler(id, p) {
    props.onAssignContract(id, p);
  }

  function declineClaimHandler(id, p) {
    props.onDeclineContract(id, p);
  }
  return (
    <>
      <CardsList>
        {contracts.map((contract) => (
          <ContratItem
            key={contract.id}
            contract={contract}
            onCloseContract={closeContractHandler}
            onAssignContract={assignContractHandler}
            onDeclineContract={declineClaimHandler}
          />
        ))}
        {!contracts && "нет"}
      </CardsList>
    </>
  );
}
